<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      >
        <template #[`item.title`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-sheet
                color="transparent"
                height="100%"
                class="name-cell name"
                v-on="on" v-bind="attrs"
              >
                <span class="sliced-name">{{ item.title }}</span>
              </v-sheet>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>
        </template>
        <template #[`item.calls_count`]="{ item }">
          <div>
            {{ item.calls_count }}({{ item.calls_count_percent }}%)
          </div>
        </template>
        <template #[`item.sum_calls_duration`]="{ item }">
          <div style="white-space: nowrap;">
            {{ item.sum_calls_duration }}сек.({{ item.sum_calls_duration_in_min }}мин.)
          </div>
        </template>
        <template #[`item.holds_percent`]="{ item }">
          <div>
            {{ item.holds_percent }}%
          </div>
        </template>
      </v-data-table>

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GroupByOperator',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headers: [
          {text: 'Оператор', value: 'title'},
          {text: 'Количество вызовов', value: 'calls_count'},
          {text: 'Суммарное время разговора', value: 'sum_calls_duration'},
          {text: 'Среднее время разговора (сек.)', value: 'avg_call_duration'},
          {text: 'Суммарное время удержания, сек', value: 'sum_holds_duration'},

          {text: '% удержания (Hold)', value: 'holds_percent'},

          {text: 'Макс время удержания, сек', value: 'max_hold_duration'},
          {text: 'Среднее время удержания, сек', value: 'avg_hold_duration'},

          {text: 'Суммарное время постобработки, сек', value: 'sum_postprocessing'},
          {text: 'Среднее время постобработки, сек', value: 'avg_postprocessing'},
        ],
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadGroupByOperatorWidget: 'dashboard/loadGroupByOperatorWidget',
    }),

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadGroupByOperatorWidget(this.widget.params);
      this.isLoaded = true;
    },
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>